"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TripRouteSummaryCardContainer = TripRouteSummaryCardContainer;
exports.shouldShowTripRouteSummary = shouldShowTripRouteSummary;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _TripRouteSummaryCard = require("@/components/purchase/TripRouteSummaryCard/TripRouteSummaryCard");
var _passengerCategorySlots = _interopRequireDefault(require("@/utils/passengerCategorySlots"));
// Terminal-based searches get the summary card unless the brand opts back into the trip info bar.
function shouldShowTripRouteSummary(typeOfSearch, isDisabled) {
  return !isDisabled && ['mixed', 'terminal'].includes(typeOfSearch !== null && typeOfSearch !== void 0 ? typeOfSearch : '');
}
function TripRouteSummaryCardContainer(_ref) {
  var onChangeSchedule = _ref.onChangeSchedule,
    onShowDetails = _ref.onShowDetails;
  // Narrow selectors: this container is mounted twice (mobile and sidebar), so it subscribes only
  // to the Immutable slices it reads; unrelated purchase updates keep the same references.
  var departureFragment = (0, _reactRedux.useSelector)(function (state) {
    return state.purchase.getIn(['departs', 'fragments', 0]);
  });
  var departsDeparture = (0, _reactRedux.useSelector)(function (state) {
    return state.purchase.getIn(['departs', 'departure']);
  });
  // Reservation-level endpoints span every fragment (connections, bus + flight); the first
  // fragment alone would show the stopover as the destination.
  var departsOrigin = (0, _reactRedux.useSelector)(function (state) {
    return state.purchase.getIn(['departs', 'origin']);
  });
  var departsDestination = (0, _reactRedux.useSelector)(function (state) {
    return state.purchase.getIn(['departs', 'destination']);
  });
  var isRoundTrip = (0, _reactRedux.useSelector)(function (state) {
    return state.purchase.get('roundTrip') === true;
  });
  var returnFragment = (0, _reactRedux.useSelector)(function (state) {
    return state.purchase.getIn(['returns', 'fragments', 0]);
  });
  var returnsDeparture = (0, _reactRedux.useSelector)(function (state) {
    return state.purchase.getIn(['returns', 'departure']);
  });
  var purchasePassengers = (0, _reactRedux.useSelector)(function (state) {
    return state.purchase.get('passengers');
  });
  var purchasePassengerSelection = (0, _reactRedux.useSelector)(function (state) {
    return state.purchase.get('passengerSelection');
  });
  var searchPassengers = (0, _reactRedux.useSelector)(function (state) {
    var _state$search;
    return (_state$search = state.search) === null || _state$search === void 0 ? void 0 : _state$search.get('passengers');
  });
  var isFlat = (0, _reactRedux.useSelector)(function (state) {
    var _state$whitelabelConf;
    return ((_state$whitelabelConf = state.whitelabelConfig) === null || _state$whitelabelConf === void 0 || (_state$whitelabelConf = _state$whitelabelConf.features) === null || _state$whitelabelConf === void 0 ? void 0 : _state$whitelabelConf.FUNNEL_STYLE) === 'FLAT';
  });
  var origin = departsOrigin || (departureFragment === null || departureFragment === void 0 ? void 0 : departureFragment.get('origin'));
  var destination = departsDestination || (departureFragment === null || departureFragment === void 0 ? void 0 : departureFragment.get('destination'));
  var passengers = _react["default"].useMemo(function () {
    var _purchasePassengers$t, _purchasePassengerSel, _searchPassengers$toJ;
    var existingPassengers = (_purchasePassengers$t = purchasePassengers === null || purchasePassengers === void 0 ? void 0 : purchasePassengers.toJS()) !== null && _purchasePassengers$t !== void 0 ? _purchasePassengers$t : [];
    if (existingPassengers.length) return existingPassengers;
    var purchaseSelection = (_purchasePassengerSel = purchasePassengerSelection === null || purchasePassengerSelection === void 0 ? void 0 : purchasePassengerSelection.toJS()) !== null && _purchasePassengerSel !== void 0 ? _purchasePassengerSel : {};
    var searchSelection = (_searchPassengers$toJ = searchPassengers === null || searchPassengers === void 0 ? void 0 : searchPassengers.toJS()) !== null && _searchPassengers$toJ !== void 0 ? _searchPassengers$toJ : {};
    var selectionForDisplay = (0, _passengerCategorySlots["default"])(purchaseSelection, searchSelection) ? searchSelection : purchaseSelection;
    return Object.entries(selectionForDisplay).flatMap(function (_ref2) {
      var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
        busCategory = _ref3[0],
        count = _ref3[1];
      return Array.from({
        length: count
      }, function () {
        return {
          busCategory: busCategory
        };
      });
    });
  }, [purchasePassengers, purchasePassengerSelection, searchPassengers]);
  return /*#__PURE__*/_react["default"].createElement(_TripRouteSummaryCard.TripRouteSummaryCard, {
    departureDate: departsDeparture || (departureFragment === null || departureFragment === void 0 ? void 0 : departureFragment.get('departure')) || null,
    destinationCity: (destination === null || destination === void 0 ? void 0 : destination.get('cityName')) || '',
    destinationTerminal: (destination === null || destination === void 0 ? void 0 : destination.get('name')) || (destination === null || destination === void 0 ? void 0 : destination.get('cityName')) || '',
    isFlat: isFlat,
    isOpenTicket: (departureFragment === null || departureFragment === void 0 ? void 0 : departureFragment.get('openTicket')) === true,
    isReturnOpenTicket: (returnFragment === null || returnFragment === void 0 ? void 0 : returnFragment.get('openTicket')) === true,
    isRoundTrip: isRoundTrip,
    onChangeSchedule: onChangeSchedule,
    onShowDetails: onShowDetails,
    originCity: (origin === null || origin === void 0 ? void 0 : origin.get('cityName')) || '',
    originTerminal: (origin === null || origin === void 0 ? void 0 : origin.get('name')) || (origin === null || origin === void 0 ? void 0 : origin.get('cityName')) || '',
    passengers: passengers,
    returnDate: returnsDeparture || (returnFragment === null || returnFragment === void 0 ? void 0 : returnFragment.get('departure')) || null,
    "data-sentry-element": "TripRouteSummaryCard",
    "data-sentry-component": "TripRouteSummaryCardContainer",
    "data-sentry-source-file": "index.tsx"
  });
}